import { toast } from 'react-toastify';

export class LinhasDeCuidadoFormularioValidation {
  fields = [];
  errors = [];
  notFound = ['99/99/9999', '999', '99', '99:99', '99:99:99'];
  exceptions = ['98/98/9998', '98:98', '98:98:98'];
  setFields(fields) {
    this.fields = fields;
  }

  getErrors() {
    return this.errors;
  }

  validateForms(forms) {
    //not implented (obs caso acha a necessidade de fazer as validacoes frontend sera implementado nessa funcao)
    return true;
  }

  validFormat(field, value) {
    let _field = this.fields[field] ? this.fields[field] : null;
    if (_field == null) return { isValid: false };
    if (value == '' || value == null) return { isValid: true };
    let bol = false;

    switch (_field.type) {
      case 'date': //TODO: Criar as exceptions 99/99/99999 e 98/98/9998
        bol = this.isDate(value);
        break;
      case 'time': //TODO: Criar as exceptions 99/99/99999 e 98/98/9998
        bol = this.isTime(value);
        break;
      case 'number':
        bol = this.isNumber(value);
        break;
      case 'float':
        bol = this.isFloat(value, _field.pattern);
        break;
      case 'text':
        bol = true;
        break;
      default:
        bol = true;
        break;
    }
    return { isValid: bol };
  }

  /*
      Logica das funcoes repetidas no frontend
  */
  validateRequired = field => {
    return field != null && field != '' ? true : false;
  };

  isDate = value => {
    console.log('value isDate :>> ', value);

    // if (this.exceptions.indexOf(value) < 0) {
    var reg = /(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.]([1-9])\d\d/;

    if (!value.match(reg)) {
      toast.error(`A data "${value}" informada é inválida.`, {
        autoClose: 5000,
      });
    }

    return value.match(reg) ? true : false;
    //   }
    //  return true;
  };

  isNumber = value => {
    var reg = /^[0-9]*$/gm;

    if (!value.match(reg)) {
      toast.error(`Informe um número válido.`, {
        autoClose: 5000,
      });
    }

    return value.match(reg) ? true : false;
  };

  isTime = value => {
    var reg = /^([0-1]?[0-9]|2[0-3]):([0-5][0-9])?$/;

    if (!value.match(reg)) {
      toast.error(`O horário "${value}" informado é inválido.`, {
        autoClose: 5000,
      });
    }

    return value.match(reg) ? true : false;
  };

  isFloat = (value, pattern) => {
    var reg = new RegExp(pattern);

    if (!value.match(reg)) {
      toast.error(`Informe um número válido.`, {
        autoClose: 5000,
      });
    }

    return value.match(reg) ? true : false;
  };
}
